import { Box, Grid2, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useMemo } from "react";

const boxStyles = {
  flex: 1,
  minWidth: 200,
  maxWidth: 400,
  height: "auto",
  border: "1px solid #000",
  borderRadius: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 3,
  p: 2,
};

const Solutions = () => {
  const theme = useTheme();

  const isLgScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const ismdScreen = useMediaQuery(theme.breakpoints.up("md"));

  const web_view = useMemo(() => {
    return (
      <Box
        sx={{
          background: theme.palette.primary.white,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          paddingTop: 4,
          paddingBottom: 4,
        }}
      >
        <Box
          sx={{
            width: "85%",
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: "#000",
              fontSize: {
                xs: "2.5rem",
                sm: "3rem",
                md: "3rem",
                laptop: "3.5rem",
                lg: "4rem",
                xl: "4.25rem",
              },
            }}
            variant="h2"
          >
            Our{" "}
            <span style={{ color: "#0D2B4E" }}>
              <i>Solutions</i>
            </span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  ...boxStyles,
                  maxWidth: 600,
                  borderBottom: "none",
                  border: "1px solid rgba(0, 0, 0, 0.21)",
                  borderRadius: 3,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "1.3rem",
                      laptop: "1.5rem",
                    },
                  }}
                >
                  Seamless User Experience
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "0.8rem",
                      laptop: "0.9rem",
                      lg: "1rem",
                      xl: "1.225rem",
                    },
                  }}
                >
                  Building intuitive, high-performance web and mobile
                  applications that elevate user engagement, accessibility, and
                  business success.
                </Typography>
              </Box>
              <Box
                sx={{
                  ...boxStyles,
                  maxWidth: 600,
                  borderBottom: "none",
                  border: "1px solid rgba(0, 0, 0, 0.21)",
                  borderRadius: 3,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "1.3rem",
                      laptop: "1.5rem",
                    },
                  }}
                >
                  Data Analytics & Business Intelligence
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "0.8rem",
                      laptop: "0.9rem",
                      lg: "1rem",
                      xl: "1.225rem",
                    },
                  }}
                >
                  Transform raw data into actionable insights with advanced
                  analytics, visualization, and strategic decision-making tools
                  to drive business growth.
                </Typography>
              </Box>
              <Box
                sx={{
                  ...boxStyles,
                  maxWidth: 600,
                  borderBottom: "none",
                  border: "1px solid rgba(0, 0, 0, 0.21)",
                  borderRadius: 3,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "1.3rem",
                      laptop: "1.5rem",
                    },
                  }}
                >
                  SaaS & Digital Acceleration
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "0.8rem",
                      laptop: "0.9rem",
                      lg: "1rem",
                      xl: "1.225rem",
                    },
                  }}
                >
                  Designing and scaling SaaS platforms that enhance automation,
                  improve efficiency, and integrate seamlessly with business
                  workflows.
                </Typography>
              </Box>
              <Box
                sx={{
                  ...boxStyles,
                  maxWidth: 600,
                  border: "1px solid rgba(0, 0, 0, 0.21)",
                  borderRadius: 3,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "1.3rem",
                      laptop: "1.5rem",
                    },
                  }}
                >
                  Cloud Transformation & Scalability
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#000",
                    textAlign: "center",
                    fontSize: {
                      xs: "0.8rem",
                      laptop: "0.9rem",
                      lg: "1rem",
                      xl: "1.225rem",
                    },
                  }}
                >
                  We help businesses modernize infrastructure, migrate to the
                  cloud, and optimize performance for better scalability,
                  security, and cost-efficiency.
                </Typography>
              </Box>
            </Box>
            <Box>
              <img
                src="/images/home/solution.png"
                alt="Globe"
                style={{
                  width: "100%",
                  maxWidth: "350px",
                  height: "auto",
                  objectFit: "contain",
                  flexShrink: 1,
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }, []);

  const mobile_view = useMemo(() => {
    return (
      <Box
        sx={{
          background: theme.palette.primary.white,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          paddingTop: 2,
          paddingBottom: 4,
        }}
      >
        <Box
          sx={{
            width: "85%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: "#000",
              fontSize: {
                xs: "2.5rem",
                sm: "3rem",
                md: "3rem",
                laptop: "3.5rem",
                lg: "4rem",
                xl: "4.25rem",
              },
            }}
            variant="h2"
          >
            Our{" "}
            <span style={{ color: "#0D2B4E" }}>
              <i>Solutions</i>
            </span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                ...boxStyles,
                maxWidth: 600,
                border: "1px solid rgba(0, 0, 0, 0.21)",
                borderRadius: 3,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "1.3rem",
                    laptop: "1.5rem",
                  },
                }}
              >
                Seamless User Experience
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                Building intuitive, high-performance web and mobile applications
                that elevate user engagement, accessibility, and business
                success.
              </Typography>
            </Box>
            <Box
              sx={{
                ...boxStyles,
                maxWidth: 600,
                border: "1px solid rgba(0, 0, 0, 0.21)",
                borderRadius: 3,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "1.3rem",
                    laptop: "1.5rem",
                  },
                }}
              >
                Data Analytics & Business Intelligence
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                Transform raw data into actionable insights with advanced
                analytics, visualization, and strategic decision-making tools to
                drive business growth.
              </Typography>
            </Box>
            <Box>
              <img
                src="/images/home/solution.png"
                alt="Globe"
                style={{
                  width: "100%",
                  maxWidth: "250px",
                  height: "auto",
                  objectFit: "contain",
                  flexShrink: 1,
                }}
              />
            </Box>
            <Box
              sx={{
                ...boxStyles,
                maxWidth: 600,
                border: "1px solid rgba(0, 0, 0, 0.21)",
                borderRadius: 3,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "1.3rem",
                    laptop: "1.5rem",
                  },
                }}
              >
                SaaS & Digital Acceleration
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                Designing and scaling SaaS platforms that enhance automation,
                improve efficiency, and integrate seamlessly with business
                workflows.
              </Typography>
            </Box>
            <Box
              sx={{
                ...boxStyles,
                maxWidth: 600,
                border: "1px solid rgba(0, 0, 0, 0.21)",
                borderRadius: 3,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "1.3rem",
                    laptop: "1.5rem",
                  },
                }}
              >
                Cloud Transformation & Scalability
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#000",
                  textAlign: "center",
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We help businesses modernize infrastructure, migrate to the
                cloud, and optimize performance for better scalability,
                security, and cost-efficiency.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }, [theme.palette.primary.white]);

  if (isLgScreen) {
    return (
      <Box
        sx={{
          background: theme.palette.primary.white,

          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          paddingTop: 8,
          paddingBottom: 8,
        }}
      >
        <Box
          sx={{
            width: "85%",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <Typography sx={{ textAlign: "center", color: "#000" }} variant="h2">
            Our{" "}
            <span style={{ color: "#0D2B4E" }}>
              <i>Solutions</i>
            </span>
          </Typography>

          <Grid2
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            {/* Left Side */}
            <Grid2
              item
              xs={12}
              lg={4}
              display="flex"
              flexDirection="column"
              sx={{
                // width: { lg: "100%", xl: "50%" },
                gap: { lg: 0, xl: 16 },
              }}
            >
              <Box sx={boxStyles}>
                <Typography
                  variant="h4"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  Seamless User Experience
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  Building intuitive, high-performance web and mobile
                  applications that elevate user engagement, accessibility, and
                  business success.
                </Typography>
                {/* <svg
                  width="120"
                  height="120"
                  style={{
                    position: "absolute",
                    bottom: "-20px",
                    right: "-120px",
                  }}
                >
                  <path
                    d="M 0 20 L 100 50 L 140 80"
                    stroke="black"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg> */}
              </Box>

              <Box sx={boxStyles}>
                <Typography
                  variant="h4"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  Data Analytics & Business Intelligence
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  Transform raw data into actionable insights with advanced
                  analytics, visualization, and strategic decision-making tools
                  to drive business growth.
                </Typography>
              </Box>
            </Grid2>

            {/* Center Image */}
            <Grid2
              item
              xs={12}
              display="flex"
              // justifyContent="center"
              sx={{
                justifyContent: { xs: "flex-start", xl: "center" },
              }}
            >
              <img
                src="/images/home/solution.png"
                alt="Globe"
                style={{
                  width: "100%",
                  maxWidth: "350px",
                  height: "auto",
                  objectFit: "contain",
                  flexShrink: 1,
                }}
              />
            </Grid2>

            {/* Right Side */}
            <Grid2
              item
              xs={12}
              lg={4}
              display="flex"
              flexDirection="column"
              sx={{
                // width: { lg: "100%", xl: "50%" },
                gap: { lg: 0, xl: 16 },
              }}
            >
              <Box sx={boxStyles}>
                <Typography
                  variant="h4"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  SaaS & Digital Acceleration
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  Designing and scaling SaaS platforms that enhance automation,
                  improve efficiency, and integrate seamlessly with business
                  workflows.
                </Typography>
              </Box>
              <Box sx={boxStyles}>
                <Typography
                  variant="h4"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  Cloud Transformation & Scalability
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#000", textAlign: "center" }}
                >
                  We help businesses modernize infrastructure, migrate to the
                  cloud, and optimize performance for better scalability,
                  security, and cost-efficiency.
                </Typography>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    );
  }

  return (
    <>
      {ismdScreen && web_view}
      {!ismdScreen && mobile_view}
    </>
  );
};

export default Solutions;
